import { MOUSE } from 'three';

export class ViewController {
  constructor(jsonData, loadedModel, controls, defaultCamera) {
    window.toggleSpecification = this.toggleSpecification.bind(this);
    window.changeControl = this.changeControl.bind(this);
    window.setCamPreset = this.setCamPreset.bind(this);

    this.jsonData = jsonData;
    this.loadedModel = loadedModel;
    this.controls = controls;
    this.defaultCamera = defaultCamera;
  }

  saveImage(images) {
    // Create temporary print division
    const print = document.createElement('div');
    print.id = 'print';

    // Header
    const header = document.createElement('div');
    header.id = 'print_header';
    print.appendChild(header);

    const headText = document.createElement('h4');
    headText.classList.add('spechead');
    headText.innerHTML =
      '標準型エレベーター アーバンエース HF Mirai<br>デザインシミュレーション スペックシート';
    header.appendChild(headText);

    const headImg = document.createElement('img');
    headImg.classList.add('speclogo');
    headImg.src = 'assets/images/01_layout/CS_logo2.png';
    headImg.style.objectFit = 'contain';
    headImg.style.height = '55%';
    header.appendChild(headImg);

    print.appendChild(document.createElement('hr'));

    // Headline
    const Sub = document.createElement('h3');
    Sub.classList.add('spechead');
    if (this.loadedModel.component == 'Cage') Sub.innerHTML += 'かご内';
    else Sub.innerHTML += '乗場';
    switch (this.loadedModel.type) {
      case 'P11': {
        Sub.innerHTML += ' 乗用（P） 11人乗り';
        break;
      }
      case 'P24': {
        Sub.innerHTML += ' 乗用（P） 24人乗り';
        break;
      }
      case 'B750': {
        Sub.innerHTML += ' 寝台用（B） 1300mm×2300mm';
        break;
      }
      case 'R9': {
        Sub.innerHTML += ' 住宅用（R） 9人乗り';
        break;
      }
      case 'EP26': {
        Sub.innerHTML += ' 非常用（EP） 1800mm×2000mm';
        break;
      }
    }
    print.appendChild(Sub);

    // Contents
    const printcontentsdiv = document.createElement('div');
    printcontentsdiv.id = 'print_content';
    print.appendChild(printcontentsdiv);

    // Images
    const imagewrap = document.createElement('div');
    imagewrap.id = 'print_imagewrap';
    images.forEach((img) => {
      img.style.width = 100 / images.length + '%';
      if (this.loadedModel.component == 'Hall') img.style.objectFit = 'cover';
      imagewrap.appendChild(img);
    });
    if (this.loadedModel.type == 'B750' && this.loadedModel.component == 'Cage')
      imagewrap.style.paddingRight = '20px';
    printcontentsdiv.appendChild(imagewrap);

    let activeIds = new Object();

    // Get current value
    Array.from(
      document.getElementById('custom_ui').getElementsByTagName('input')
    ).forEach((input) => {
      if (input.type == 'radio' && input.checked) {
        activeIds[input.name] = input.value;
      }
    });

    // Build specification table
    const printspec = document.createElement('div');
    printspec.id = 'printspec';
    printcontentsdiv.appendChild(printspec);

    const printtable = document.createElement('table');
    printtable.setAttribute('border', '1');
    printspec.appendChild(printtable);

    const tbody = document.createElement('tbody');
    printtable.appendChild(tbody);

    // For option
    const opttable = document.createElement('table');
    opttable.style.border = '1px solid #999';
    const opttbody = document.createElement('tbody');
    opttable.appendChild(opttbody);

    for (const category of this.jsonData) {
      for (const part of category.parts) {
        if (part.speclabel === undefined) continue;
        for (const pattern of part.patterns) {
          if (
            pattern.id == activeIds[part.id] &&
            pattern.speclabel != undefined
          ) {
            let cattrEl, parttdEl, patterntdEl;
            cattrEl = printspec.querySelector('.spectr_' + part.speclabel);
            if (!cattrEl) {
              // Avoid handrail if set to Off
              if (
                (part.id == 'handrail_type' || part.id == 'wc_andrail_type') &&
                activeIds['handrail_position'] == 'handrail_position_Off'
              )
                continue;

              // Row not defined
              cattrEl = document.createElement('tr');
              cattrEl.classList.add('spectr_' + part.speclabel);

              parttdEl = document.createElement('td');
              parttdEl.innerHTML += part.speclabel;
              patterntdEl = document.createElement('td');

              if (part.speclabel == 'オプション') {
                if (opttbody.childElementCount == 0)
                  printspec.appendChild(opttable);
                parttdEl.style.verticalAlign = 'top';
                opttbody.appendChild(cattrEl);
              } else tbody.appendChild(cattrEl);
              cattrEl.appendChild(parttdEl);
              cattrEl.appendChild(patterntdEl);
            } else {
              // Row defined
              patterntdEl = cattrEl.lastElementChild;
              patterntdEl.innerHTML += '<br/>';
            }
            if (part.id == 'designpanel_color') {
              let txt = patterntdEl.innerHTML
                .split(/<br[/s]?[\/]?>/)
                .filter(Boolean);
              txt[txt.length - 1] = `${pattern.speclabel}${
                txt[txt.length - 1]
              }`;
              patterntdEl.innerHTML = txt.join('<br/>');
            } else if (part.id == 'ceiling_color') {
              patterntdEl.innerHTML = patterntdEl.innerHTML.replace(
                '＜天井色＞',
                pattern.speclabel
              );
            } else
              patterntdEl.innerHTML += pattern.speclabel.replaceAll(
                '／',
                '<br/>'
              );
          }
        }
      }
    }

    // Footer
    const footer = document.createElement('div');
    footer.id = 'print_footer';
    print.appendChild(footer);

    const imgCap = document.createElement('p');
    imgCap.style.fontSize = '0.5rem';
    imgCap.style.lineHeight = '0.6rem';
    if (this.loadedModel.component == 'Cage') imgCap.innerText += '＊かご内';
    else imgCap.innerText += '＊乗場';
    imgCap.innerText +=
      'デザインはCG合成です。実際とはかご内の明るさや色合いなど異なる場合があります。\n＊製品の改良により予告なく仕様を変更することがあります。意匠決定の際は、当社担当にお問い合わせください。';
    footer.appendChild(imgCap);

    const footImg = document.createElement('img');
    footImg.src = 'assets/images/01_layout/BS_logo2.png';
    footImg.style.objectFit = 'contain';
    footImg.style.height = '75%';
    footer.appendChild(footImg);

    // Hide other elements
    const body = document.querySelector('body');
    body.style.overflow = 'initial';
    body.appendChild(print);

    document.querySelectorAll('body>:not(#print)').forEach((el) => {
      el.classList.add('hidden');
    });

    window.onafterprint = function () {
      document.querySelectorAll('body>:not(#print)').forEach((el) => {
        el.classList.remove('hidden');
      });
      print.remove();
      body.style.overflow = '';

      window.onControl();
      window.resize();
    };

    // Set image loaded callback
    setLoadAllCallback(images.concat([headImg, footImg]), async function () {
      window.print();
    });

    this.sendGAEvent(activeIds, this.jsonData);
  }

  sendGAEvent(activeIds, jsonData) {
    let page_location = `${
      window.location.origin
    }${window.location.pathname.replace(/\/$/, '')}/${this.loadedModel.type}/${
      this.loadedModel.component
    }/`;

    // Get selected pattern index
    jsonData.forEach((element) => {
      element.parts.forEach((part) => {
        let isChecked;
        part.patterns.forEach((pattern, index) => {
          if (activeIds[part.id] == pattern.id) {
            page_location += `${pattern.id}-`;
            isChecked = true;
          }
        });

        // All disabled
        if (!isChecked) {
          page_location += `${part.id}_disabled-`;
        }
      });
    });

    page_location = page_location.slice(0, -1);

    // console.log(page_location);
    gtag('event', 'page_view', {
      page_title: 'カスタム仕様',
      page_location: page_location,
    });
  }

  toggleSpecification(e) {
    if (e && e.target.id != 'specwrap') return;

    const wrapEl = document.getElementById('specwrap');
    if (!wrapEl) return;

    if (wrapEl.style.display == '') {
      let activeIds = new Object();
      // Get current value
      Array.from(
        document.getElementById('custom_ui').getElementsByTagName('input')
      ).forEach((input) => {
        if (input.type == 'radio' && input.checked) {
          activeIds[input.name] = input.value;
        }
      });

      const typeheader = document.querySelector(
        '#spec thead tr:first-child th'
      );
      typeheader.innerText = this.loadedModel.type;
      const placeheader = document.querySelector(
        '#spec thead tr:last-child th'
      );
      if (this.loadedModel.component == 'Cage')
        placeheader.innerText = 'かご内';
      else placeheader.innerText = '乗場';

      const tbody = document.querySelector('#spec tbody');
      while (tbody.firstChild) {
        tbody.removeChild(tbody.firstChild);
      }

      for (const category of this.jsonData) {
        const cattrEl = document.createElement('tr');
        const cattdEl = document.createElement('td');
        cattdEl.innerText = category.label;
        cattrEl.appendChild(cattdEl);

        const parttdEl = document.createElement('td');
        const patterntdEl = document.createElement('td');

        let isActive = false;
        for (const part of category.parts) {
          for (const pattern of part.patterns) {
            if (pattern.id == activeIds[part.id]) {
              parttdEl.innerHTML += part.label + '<br/>';
              patterntdEl.innerHTML += pattern.name + '<br/>';
              isActive = true;
            }
          }
        }

        cattrEl.appendChild(parttdEl);
        cattrEl.appendChild(patterntdEl);
        if (isActive) tbody.appendChild(cattrEl);
      }

      wrapEl.style.display = 'flex';
    } else wrapEl.style.display = '';
  }

  changeControl(selected = null) {
    let Xflag, Yflag, Mflag, Zflag;

    // Lock controls
    this.controls.maxAzimuthAngle = this.controls.minAzimuthAngle =
      this.controls.getAzimuthalAngle();
    this.controls.maxPolarAngle = this.controls.minPolarAngle =
      this.controls.getPolarAngle();
    this.controls.enablePan = false;
    this.controls.enableZoom = true; // always true

    if (!selected) {
      const radio = document.getElementsByName('controls');
      selected = '';
      radio.forEach((r) => {
        if (r.checked) selected = r.value;
      });
    }

    const args = selected.split(',');

    args.forEach((arg) => {
      switch (arg) {
        case 'x': {
          Xflag = true;
          break;
        }
        case 'y': {
          Yflag = true;
          break;
        }
        case 'm': {
          Mflag = true;
          break;
        }
        case 'z': {
          Zflag = true;
          break;
        }
        default:
          break;
      }
    });

    if (Xflag) {
      this.controls.maxPolarAngle = Math.PI;
      this.controls.minPolarAngle = 0;
      this.controls.mouseButtons = {
        LEFT: MOUSE.ROTATE,
        MIDDLE: MOUSE.DOLLY,
      };
    }
    if (Yflag) {
      this.controls.maxAzimuthAngle = Number.POSITIVE_INFINITY;
      this.controls.minAzimuthAngle = Number.NEGATIVE_INFINITY;
      this.controls.mouseButtons = {
        LEFT: MOUSE.ROTATE,
        MIDDLE: MOUSE.DOLLY,
      };
    }
    if (Mflag) {
      this.controls.enablePan = true;
      this.controls.mouseButtons = {
        LEFT: MOUSE.PAN,
        MIDDLE: MOUSE.DOLLY,
      };
    }
    if (Zflag) {
      this.controls.enableZoom = true;
      this.controls.mouseButtons = {
        LEFT: MOUSE.DOLLY,
        MIDDLE: MOUSE.DOLLY,
      };
    }

    this.controls.update();
    this.controls.onControl();
  }

  setCamPreset(id) {
    this.controls.reset();

    // Free camera
    this.controls.maxPolarAngle = Math.PI;
    this.controls.minPolarAngle = 0;
    this.controls.maxAzimuthAngle = Number.POSITIVE_INFINITY;
    this.controls.minAzimuthAngle = Number.NEGATIVE_INFINITY;
    this.controls.enablePan = true;
    this.controls.enableZoom = true;

    switch (id) {
      // front
      case 0: {
        if (this.loadedModel.component == 'Cage') {
          switch (this.loadedModel.type) {
            case 'P24':
            case 'B750':
            case 'EP26': {
              this.defaultCamera.position.set(0, -0.28, -5.54);
              break;
            }

            default: {
              this.defaultCamera.position.set(0, -0.25, -5);
              break;
            }
          }
        } else {
          switch (this.loadedModel.type) {
            case 'P11': {
              this.defaultCamera.position.set(0.01, -0.97, -2.53);
              this.controls.target.set(0, -0.97, 2.97);
              break;
            }
            case 'P24': {
              this.defaultCamera.position.set(-0.02, -1.02, -2.37);
              this.controls.target.set(-0.07, -1.02, 3.14);
              break;
            }
            case 'R9': {
              this.defaultCamera.position.set(-2.08, -0.37, -3.65);
              this.controls.target.set(-2.11, -0.37, 1.59);
              break;
            }
            case 'B750': {
              this.defaultCamera.position.set(0, -0.23, -2.9);
              this.controls.target.set(0, -0.24, 3.2);
              break;
            }
            case 'EP26': {
              this.defaultCamera.position.set(-0.08, -0.93, -2.73);
              this.controls.target.set(-0.09, -0.91, 3.21);
              break;
            }
          }
        }
        break;
      }
      // back
      case 1: {
        if (this.loadedModel.component == 'Cage') {
          switch (this.loadedModel.type) {
            case 'P24':
            case 'B750':
            case 'EP26': {
              this.defaultCamera.position.set(0, -0.28, 5.54);
              break;
            }

            default: {
              this.defaultCamera.position.set(0, -0.25, 5);
              break;
            }
          }
        }
        break;
      }
      // panel
      case 2: {
        if (this.loadedModel.component == 'Cage') {
          this.defaultCamera.position.set(0.86, 0.39, -1.17);
          this.controls.target.set(-0.08, 0.35, -0.06);
        } else {
          switch (this.loadedModel.type) {
            case 'P11': {
              this.defaultCamera.position.set(-0.62, -1, -0.71);
              this.controls.target.set(-0.62, -0.85, 3.13);
              break;
            }
            case 'P24': {
              this.defaultCamera.position.set(-0.77, -0.92, -0.54);
              this.controls.target.set(-0.78, -0.92, 3.12);
              break;
            }
            case 'R9': {
              this.defaultCamera.position.set(-2.66, -0.06, -1.65);
              this.controls.target.set(-2.67, -0.07, 1.82);
              break;
            }
            case 'B750': {
              this.defaultCamera.position.set(-0.63, -0.05, -0.34);
              this.controls.target.set(-0.61, -0.06, 3.12);
              break;
            }
            case 'EP26': {
              this.defaultCamera.position.set(-0.78, -0.94, -0.81);
              this.controls.target.set(-0.78, -0.92, 3.03);
              break;
            }
          }
        }
        break;
      }
      // ceiling
      case 3: {
        if (this.loadedModel.component == 'Cage') {
          switch (this.loadedModel.type) {
            case 'P24':
            case 'EP26': {
              this.defaultCamera.position.set(0, -0.89, -3.2);
              this.controls.target.set(0, 0.76, -0.07);
              break;
            }
            default: {
              this.defaultCamera.position.set(0, -0.45, -2.37);
              this.controls.target.set(0, 0.76, -0.07);
              break;
            }
          }
        }
        break;
      }
      // floor
      case 4: {
        if (this.loadedModel.component == 'Cage') {
          this.defaultCamera.position.set(0, 0.3, -1.8);
          this.controls.target.set(0, -0.68, -0.41);
        }
        break;
      }
      // 45
      case 5: {
        if (this.loadedModel.component == 'Cage') {
          switch (this.loadedModel.type) {
            case 'P24':
            case 'B750':
            case 'EP26': {
              this.defaultCamera.position.set(4.32, 0, -4.32);
              break;
            }

            default: {
              this.defaultCamera.position.set(3.9, 0, -3.9);
              break;
            }
          }
        } else {
          switch (this.loadedModel.type) {
            case 'P11': {
              this.defaultCamera.position.set(3.7, -1.12, -1.93);
              this.controls.target.set(0.07, -1.12, 2.97);
              break;
            }
            case 'P24': {
              this.defaultCamera.position.set(3.85, -1.21, -1.56);
              this.controls.target.set(0.01, -1.21, 3.19);
              break;
            }
            case 'R9': {
              this.defaultCamera.position.set(1.39, -0.39, -2.33);
              this.controls.target.set(-2.09, -0.39, 1.59);
              break;
            }
            case 'B750': {
              this.defaultCamera.position.set(3.71, -0.31, -1.52);
              this.controls.target.set(-0.15, -0.32, 3.2);
              break;
            }
            case 'EP26': {
              this.defaultCamera.position.set(3.92, -1.23, -1.46);
              this.controls.target.set(-0.23, -1.21, 3.21);
              break;
            }
          }
        }
        break;
      }

      // -45
      case 6: {
        if (this.loadedModel.component == 'Cage')
          switch (this.loadedModel.type) {
            case 'P24':
            case 'B750':
            case 'EP26': {
              this.defaultCamera.position.set(-4.32, 0, 4.32);
              break;
            }

            default: {
              this.defaultCamera.position.set(-3.9, 0, 3.9);
              break;
            }
          }
        else {
          switch (this.loadedModel.type) {
            case 'P11': {
              this.defaultCamera.position.set(3.7, -1.12, -1.93);
              this.controls.target.set(0.07, -1.12, 2.97);
              break;
            }
            case 'R9': {
              this.defaultCamera.position.set(1.39, -0.39, -2.33);
              this.controls.target.set(-2.09, -0.39, 1.59);
              break;
            }
            case 'B750': {
              this.defaultCamera.position.set(3.71, -0.31, -1.52);
              this.controls.target.set(-0.15, -0.32, 3.2);
              break;
            }
          }
        }
        break;
      }

      // 45 zoomed out for B750 cage print
      case 7: {
        if (this.loadedModel.component == 'Cage')
          this.defaultCamera.position.set(4.6, 0, -4.6);
        break;
      }

      // 45 zoomed out for B750 cage print
      case 8: {
        if (this.loadedModel.component == 'Cage')
          this.defaultCamera.position.set(-4.4, 0, 4.4);
        break;
      }

      // 45 zoomed out for EP26 cage print
      case 9: {
        if (this.loadedModel.component == 'Cage')
          this.defaultCamera.position.set(4.8, 0, -4.8);
        break;
      }

      // 45 zoomed out for EP26 cage print
      case 10: {
        if (this.loadedModel.component == 'Cage')
          this.defaultCamera.position.set(-4.8, 0, 4.8);
        break;
      }
    }

    this.controls.update();

    this.changeControl();
  }
}

function setLoadAllCallback(elems, callback) {
  var count = 0;
  for (var i = 0; i < elems.length; ++i) {
    elems[i].onload = function () {
      ++count;
      if (count == elems.length) {
        // All elements have been loaded.
        callback();
      }
    };
  }
}
